export default {"src":"/_next/static/media/getYourCodeImage.6563bed1.svg","height":185,"width":556,"blurWidth":0,"blurHeight":0};